import {combineReducers} from "redux";
import backStoreRequest from "./backStockSlice";


const backStoreReducer = combineReducers({
    backStoreRequest
});

export default backStoreReducer;